export default "__VITE_ASSET__cHw6rFkZ__"